import axios from 'axios';
import ENDPOINT from './../../endpoints';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {add0StringToNumberLessThan10} from '@/util/dateTimeUtils';
import {
  REQUEST_UTILIZATION_FILTER_DATA_MODEL,
  REQUEST_UTILIZATION_USAGE_MODEL,
  REQUEST_UTILIZATION_TOTAL_SUMMARY_MODEL,
  REQUEST_UTILIZATION_TRANSITION_MODEL
} from '@/constants/azure-reserved/azureUtilizationConstants';
import {isFailResponse, addLoginUserInfoToPayload} from '@/util/apiUtils';
import store from '@/store';

export function fetchFilterData(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_FILTER_DATA_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.FILTER_DATA, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchAgreementUtilizationList(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_USAGE_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.AGREEMENT_UTILIZATION_LIST, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchAgreementUtilizationDetail(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_USAGE_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.AGREEMENT_UTILIZATION_DETAIL, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchInstanceFamilyUtilizationList(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_USAGE_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.INSTANCE_FAMILY_UTILIZATION_LIST, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchServiceUtilizationList(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_USAGE_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.SERVICE_UTILIZATION_LIST, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchTotalSummary(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_TOTAL_SUMMARY_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.TOTAL_SUMMARY, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchTransition(payload) {
  let fetchDataPayload = {
    ...REQUEST_UTILIZATION_TRANSITION_MODEL
  };

  fetchDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.AZURE_RESERVED.AZURE_UTILIZATION.TRANSITION, fetchDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data.list') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}





// WEBPACK FOOTER //
// ./src/api/azure-reserved/azure-utilization/index.js